module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-31.28e8e559.svg";